var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC3PhysicalSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13v50h50V13H13zm46 46H17V17h42v42z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36H21v4h34v-4zM38 21.86l-6 8h12l-6-8zM38 54.14l6-8H32l6 8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C3_Physical_switch.5c9f8ddb.svg";
export { SvgC3PhysicalSwitch as ReactComponent };